import React, { useState } from "react";
import style from "./style.module.css"; 
import {useSelector } from "react-redux";
import langData from "../../lang/data";

// Изменить на true, чтобы включить попап технических работ
const SHOW_MAINTENANCE_POPUP = false;

export default function ModalPrice() {
  const [isOpen, setIsOpen] = useState(SHOW_MAINTENANCE_POPUP);
  const { currentCurrency, currentLanguage } = useSelector(({ main }) => main);

  const close = () => {
    setIsOpen(false);
  };
  if (isOpen) {
    return (
      <div className={style.product_modal_block}>
        <div className={style.product_modal_bg}></div>
        <div className={style.modal_content_scrool}>
          <div className={style.modal_content_img_title}>
            <div className={`${style.modal_content_title} ${style.centerWs}`}>
            <img   src="public/WORK.png"/>
              <h3 className="second_title">{langData?.modalPrice.title[currentLanguage]} </h3>
              <span className={`toxir `}>{langData?.modalPrice.subTitle[currentLanguage]}</span>

            </div>
          </div>

          <div className={style.finish_check_block_border}>
            <div className={style.finish_check_block}>
                {langData?.modalPrice.text[currentLanguage]} 
            </div>
          </div>
          <div onClick={() => close()} className={style.close_shnor}>
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.15674L16 16.1567M16 1.15674L1 16.1567"
                stroke="#282828"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    );
  }
  return null;
}
